import React, { useEffect, useState } from 'react';
import DeleteConfirmation from '../../components/DeleteConfirmation';
import Table from '../../components/Table';

import UserAddEdit from '../../components/AddEditItems/UserAddEdit';
import Toast from '../../components/Toast';
import CaretIcon from '../../icons/caret.png';

import {
  ADD_USERS_URL,
  deleteData,
  DELETE_USERS_URL,
  EDIT_USERS_URL,
  FILE_UPLOAD_URL,
  getData,
  GET_ROLES_URL,
  GET_USERS_URL,
  postData,
  putData,
  uploadFile,
} from '../../utils/api';

import { getLoginDetails } from '../../utils/storage';

const userModel = {
  email: '',
  companyId: '',
  roleId: '',
  password: '',
  firstName: '',
  lastName: '',
  phone: '',
  address: '',
  city: '',
  state: '',
  zipcode: '',
  profileUrl: '',
  smsNumber: '',
  notes: '',
  isActive: true,
};

export const UsersList = (props) => {
  const { canDeleteUser, hierarchy, companyId = false, isAdmin, isFranchise } = getLoginDetails();
  const [userItems, setUserItems] = useState([]);
  const [rolesItems, setRolesItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isAddPopupShown, setIsAddPopupShown] = useState(false);
  const [isEditPopupShown, setIsEditPopupShown] = useState(false);
  const [isDeletePopupShown, setIsDeletePopupShown] = useState(false);
  const [itemForEdit, setItemForEdit] = useState(null);
  const [itemForDelete, setItemForDelete] = useState(null);
  const [userNameSort, setUserNameSort] = useState('asc');
  const [companySort, setCompanySort] = useState('asc');
  const [params, setParams] = useState({
    limit: 10,
    offset: 0,
    areMoreItemsAvailable: false,
    text: '',
  });
  const [toastParams, setToastParams] = useState({
    message: '',
    type: '',
    id: '',
  });
  const getRolesAndPermissions = async () => {
    try {
      const data = await getData(GET_ROLES_URL, {
        count: params.limit,
        offset: params.offset,
        companyId: companyId,
      });
      setRolesItems(
        data.list.map((role, index) => {
          return {
            id: role.roleId,
            value: role.name,
          };
        })
      );
    } catch (e) {
      console.log('ERROR', e);
    }
  };

  const getUsers = async () => {
    try {
      setIsLoading(true);
      setUserItems([]);

      const payload = {
        count: params.limit,
        offset: params.offset,
        text: params.text,
        companyId: companyId,
        userNameSort,
        companySort,
        isEmbed: true,
      };

      if (hierarchy === 1) {
        payload.isFranchise = window.location.pathname.includes('/Franchise')
          ? true
          : false;
      }

      const data = await getData(GET_USERS_URL, payload);
      setIsLoading(false);
      setUserItems(data.list);
      setParams({
        ...params,
        areMoreItemsAvailable: data.areMoreItemsAvailable,
      });
    } catch (e) {
      console.log('ERROR', e);
    }
  };

  useEffect(() => {
    getUsers();
  }, [
    params.offset,
    params.text,
    params.limit,
    props.match && props.match.params && props.match.params.entityId,
    userNameSort,
    companySort,
    window.location.pathname.includes('/Franchise'),
  ]);

  useEffect(() => {
    getRolesAndPermissions();
  }, []);

  const fetchMore = () => {
    setParams({
      ...params,
      offset: params.offset + params.limit,
    });
  };
  const fetchLess = () => {
    setParams({
      ...params,
      offset: params.offset - params.limit,
    });
  };
  const onSearchChange = (text) => {
    setParams({
      ...params,
      text,
      offset: 0,
    });
  };

  const addItem = async (data, image) => {
    setIsLoading(true);
    try {
      const body = {
        ...data,
        companyId: props.match.params.entityId,
        hierarchy,
        isAdmin,
        isFranchise,
      };
      if (image) {
        const response = await uploadFile(FILE_UPLOAD_URL, image.file);
        body.profileUrl = response.imageUrl;
      }
      const response = await postData(ADD_USERS_URL, body);
      setIsAddPopupShown(false);
      setToastParams({
        type: 'SUCCESS',
        message: 'Successfully added the User',
        id: new Date().getTime(),
      });
      setIsLoading(false);
      getUsers();
    } catch (e) {
      console.log('ERROR');
      setToastParams({
        type: 'ERROR',
        message:
          e && e.error
            ? e.error
            : 'Oops! Something went wrong. Please try again later',
        id: new Date().getTime(),
      });
      setIsLoading(false);
    }
  };
  const editItem = async (data, image) => {
    setIsLoading(true);
    try {
      const body = { ...data };
      if (image) {
        const response = await uploadFile(FILE_UPLOAD_URL, image.file);
        body.profileUrl = response.imageUrl;
      }
      const response = await putData(EDIT_USERS_URL, body);
      setIsEditPopupShown(false);
      setToastParams({
        type: 'SUCCESS',
        message: 'Successfully edited the User',
        id: new Date().getTime(),
      });
      setIsLoading(false);
      getUsers();
    } catch (e) {
      console.log('ERROR');
      setToastParams({
        type: 'ERROR',
        message:
          e && e.error
            ? e.error
            : 'Oops! Something went wrong. Please try again later',
        id: new Date().getTime(),
      });
      setIsLoading(false);
    }
  };
  const onIsActiveChange = (item, isActive) => {
    editItem({
      ...item,
      isActive,
    });
  };
  const deleteItem = async () => {
    setIsLoading(true);
    try {
      const response = await deleteData(DELETE_USERS_URL, {
        userId: itemForDelete.userId,
        companyId: itemForDelete.companyId,
      });
      setIsDeletePopupShown(false);
      setIsLoading(false);
      getUsers();
    } catch (e) {
      setIsLoading(false);
      console.log('ERROR');
    }
  };
  const setEdit = (item) => {
    setIsEditPopupShown(true);
    setItemForEdit(item);
  };
  const setDelete = (item) => {
    setIsDeletePopupShown(true);
    setItemForDelete(item);
  };

  return (
    <>
      {!props.hideBack && !isAddPopupShown && !isEditPopupShown ? (
        <div
          className='flex flex-middle c-pointer mb-20'
          onClick={props.onBack}
        >
          <img src={CaretIcon} className='wt-20 rotate-90 op-5' />
          <span className='fs-12 c-table-header fw-bolder'>
            Back to Setting
          </span>
        </div>
      ) : null}
      {!isAddPopupShown && !isEditPopupShown && (
        <Table
          scrollTable={true}
          type='user'
          columns={[
            () => {
              return (
                <span>
                  Username{' '}
                  {userNameSort === 'asc' ? (
                    <span
                      className={'fs-16 c-pointer'}
                      onClick={() => setUserNameSort('desc')}
                    >
                      ↓
                    </span>
                  ) : (
                    <span
                      className={'fs-16 c-pointer'}
                      onClick={() => setUserNameSort('asc')}
                    >
                      ↑
                    </span>
                  )}
                </span>
              );
            },
            'Email',
            'Address',
            () => {
              return (
                <span>
                  Company Name{' '}
                  {companySort === 'asc' ? (
                    <span
                      className={'fs-16 c-pointer'}
                      onClick={() => setCompanySort('desc')}
                    >
                      ↓
                    </span>
                  ) : (
                    <span
                      className={'fs-16 c-pointer'}
                      onClick={() => setCompanySort('asc')}
                    >
                      ↑
                    </span>
                  )}
                </span>
              );
            },
            'Role',
            'Is Active?',
          ]}
          // className="wt-600"
          items={userItems.map((entity) => {
            const createdDate = new Date(entity.createdDate);
            const dd = String(createdDate.getDate()).padStart(2, '0');
            const mm = String(createdDate.getMonth() + 1).padStart(2, '0'); //January is 0!
            const yyyy = createdDate.getFullYear();
            let hours = createdDate.getHours();
            let minutes = createdDate.getMinutes();
            const ampm = hours >= 12 ? 'pm' : 'am';
            hours = hours % 12;
            hours = hours ? hours : 12;
            minutes = minutes < 10 ? '0' + minutes : minutes;

            return {
              ...entity,
              displayAddress: `${entity.address || ''} ${entity.city || ''} ${
                entity.state || ''
              } ${entity.zipcode || ''}`,
              name: `${entity.firstName || ' '} ${entity.lastName || ' '}`,
              displayIsActive: entity.isActive ? 'YES' : 'NO',
              displayIsAdmin: entity.isAdmin ? 'YES' : 'NO',
              companyNameAndDate: `semicolon-separated-inline-${entity.companyName}; ${mm}-${dd}-${yyyy}`,
            };
          })}
          keys={[
            'name',
            'email',
            'displayAddress',
            'companyNameAndDate',
            'type',
            'displayIsActive',
          ]}
          widthClasses={[
            'flex-1',
            'flex-1',
            'flex-1',
            'flex-1',
            'wt-100',
            'wt-100',
          ]}
          headerBgWhite={true}
          actions={['EDIT', canDeleteUser && 'DELETE']}
          onEdit={setEdit}
          onDelete={setDelete}
          onChange={onSearchChange}
          onIsActiveChange={onIsActiveChange}
          offset={params.offset}
          areMoreItemsAvailable={params.areMoreItemsAvailable}
          fetchMore={fetchMore}
          fetchLess={fetchLess}
          isLoading={isLoading}
          hideCheckBox={true}
          onCountChange={(value) => {
            setParams({
              ...params,
              limit: value,
              offset: 0,
              areMoreItemsAvailable: false,
            });
          }}
          limit={params.limit}
          className='min-wt-1000'

          // widthClasses={['wt-200', 'wt-200', 'wt-150', 'wt-300', 'flex-1']}
        />
      )}

      {isAddPopupShown && (
        <UserAddEdit
          item={{ ...userModel }}
          isLoading={isLoading}
          onClose={setIsAddPopupShown.bind(null, false)}
          onBack={setIsAddPopupShown.bind(null, false)}
          onSave={addItem}
          type='add'
          roles={rolesItems}
          selected={[]}
        />
      )}
      {isEditPopupShown && (
        <UserAddEdit
          item={{ ...itemForEdit }}
          isLoading={isLoading}
          onClose={setIsEditPopupShown.bind(null, false)}
          onBack={setIsEditPopupShown.bind(null, false)}
          onSave={editItem}
          type='edit'
          roles={rolesItems}
          selected={[
            {
              id: itemForEdit.roleId,
              value: (
                rolesItems.find((role) => {
                  return role.id === itemForEdit.roleId;
                }) || {}
              ).value,
            },
          ]}
        />
      )}
      {isDeletePopupShown && (
        <DeleteConfirmation
          type='user'
          name={itemForDelete.name}
          onClose={setIsDeletePopupShown.bind(null, false)}
          onConfirm={deleteItem}
        />
      )}
      <Toast
        type={toastParams.type}
        message={toastParams.message}
        id={toastParams.id}
      />
    </>
  );
};

export default UsersList;
